<app-initial-welcome-screen-solo
  *ngIf="showWelcomeScreen"
  (closeWelcomeScreen)="closeInitialWelcomeScreen()"
  class="fixed top-0 left-0 w-full h-screen z-[999999] bg-black"
></app-initial-welcome-screen-solo>

<app-navbar
  class="w-full visible-fade-in row-span-2 w-screen"
  style="z-index: 999; top: 0 !important"
></app-navbar>

<div *ngIf="true" class="flex flex-row h-svh visible-fade-in w-full">
  <div class="static h-full md:w-64 flex-shrink-0">
    <div
      class="fixed md:relative inset-y-0 left-0 w-full h-full bg-black bg-opacity-50 text-white space-y-6 transform -translate-x-full transition-transform duration-300 ease-in-out z-50 md:translate-x-0 overflow-hidden"
      (click)="toggleDrawer()"
      [ngClass]="{
        'translate-x-0': isDrawerOpen,
        '-translate-x-full': !isDrawerOpen,
      }"
    >
      <nav
        class="w-64 bg-black p-4 h-screen overflow-auto flex flex-col justify-evenly gap-1"
      >
        <ul class="flex flex-col gap-1 navlist" style="list-style: none">
          <li>
            <a
              routerLink="/home"
              class="block p-2 navItem rounded text-center"
              (click)="$event.stopPropagation(); isDrawerOpen = false"
              [routerLink]="['/home']"
              routerLinkActive="router-link-active"
              >HOME</a
            >
          </li>
          <li>
            <a
              routerLink="/our-services"
              routerLinkActive="router-link-active"
              class="block p-2 navItem rounded text-center"
              (click)="$event.stopPropagation(); isDrawerOpen = false"
              >OUR SERVICES</a
            >
          </li>
          <li>
            <a
              routerLink="/payment-details"
              routerLinkActive="router-link-active"
              class="block p-2 navItem rounded text-center"
              (click)="$event.stopPropagation(); isDrawerOpen = false"
              >PAYMENT DETAILS</a
            >
          </li>
          <li>
            <a
              routerLink="/contact-us"
              routerLinkActive="router-link-active"
              class="block p-2 navItem rounded text-center"
              (click)="$event.stopPropagation(); isDrawerOpen = false"
              >CONTACT US</a
            >
          </li>
        </ul>

        <ul
          *ngFor="let _cCats of chunkedCats"
          class="flex flex-col gap-1 navlist"
          style="list-style: none"
        >
          <li *ngFor="let nav of _cCats">
            <a
              [routerLink]="[nav.slug]"
              routerLinkActive="router-link-active"
              class="p-2 navItem text-white flex flex-row rounded items-center gap-2"
              (click)="$event.stopPropagation(); isDrawerOpen = false"
            >
              <img
                [alt]="'click. all products for the category ' + nav.label"
                [ariaLabel]="
                  'click. all products for the category ' + nav.label
                "
                [src]="getIcon(nav.icon!)"
                loading="lazy"
                class="aspect-square"
                style="
                  width: 38px;
                  height: 38px;
                  object-fit: contain;
                  object-position: center;
                "
              />
              {{ navLabelConcat(nav!.label!) }}</a
            >
          </li>
        </ul>

        <div class="h-32 flex-shrink-0 w-full"></div>
      </nav>
    </div>
  </div>
  
  <div class="overflow-auto flex-1 h-full">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- <a class="block md:hidden" style="position: fixed; bottom: 10px; left: -5px; width: 150px; height: 150px;     z-index: 9999;" href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
    ><img
      src="https://www.bw2024.lk/vote4us.png"
      alt="logo"
      width="150"
      height="150"

  /></a> -->

<button
  matTooltip="Scroll to top"
  matTooltipPosition="left"
  *ngIf="scrollPos > 100"
  (click)="goToTop()"
  aria-label="connect with softnet computers via whatsapp"
  class="animate__animated animate__jello animate__slow animate__delay-4s animate__infinite rounded bg-white drop-shadow-md"
  style="
    position: fixed;
    right: 8px;
    bottom: 148px;
    width: 50px;
    height: 50px;
    z-index: 9999;
    border-radius: 200px;
    background-clip: padding-box;
  "
>
  <img
    src="../assets/graphics/keyboard_arrow_up_24dp_FILL0_wght400_GRAD0_opsz24.svg"
    loading="eager"
    alt="connect with softnet computers via whatsapp"
    width="50px"
    height="50px"
    style="background-clip: padding-box; border-radius: 200px"
  />
</button>

<a
  matTooltip="Connect with softnet computers via whatsap"
  matTooltipPosition="left"
  href="https://api.whatsapp.com/send/?phone=%2B94772553478&text&app_absent=0"
  aria-label="connect with softnet computers via whatsapp"
  class="animate__animated animate__jello animate__slow animate__delay-4s animate__infinite"
  style="
    position: fixed;
    right: 8px;
    bottom: 88px;
    width: 50px;
    height: 50px;
    z-index: 9999;
    border-radius: 200px;
    background-clip: padding-box;
  "
>
  <img
    src="../assets/graphics/whatsapp.svg"
    loading="eager"
    class="drop-shadow-md"
    alt="connect with softnet computers via whatsapp"
    width="50px"
    height="50px"
    style="background-clip: padding-box; border-radius: 200px"
  />
</a>

<section
  *ngIf="!cookie"
  style="z-index: 9999999"
  class="fixed max-w-md p-4 mx-auto bg-black border border-b-4 border-r-4 border-[#ff4d06] left-8 md:left-12 bottom-10 rounded-xl"
>
  <h2 class="font-semibold text-white">🍪 Cookie Notice</h2>

  <p class="mt-4 text-md text-gray-200 dark:text-gray-300">
    We use cookies!
    <a routerLink="/cookie-policy" class="text-blue-500 hover:underline"
      >Read cookies policies</a
    >.
  </p>

  <div class="flex items-center justify-end mt-4 gap-x-4 shrink-0">
    <button
      (click)="acceptCookies()"
      aria-label="acccept cookie"
      class="inline-flex text-[#ff4d06] bg-black border-0 py-2 px-6 focus:outline-none hover:bg-red-900 rounded font-bold text-xs"
    >
      Accept
    </button>
  </div>
</section>


<!-- removed owl theme  ,
              "node_modules/ngx-owl-carousel-o/lib/styles/prebuilt-themes/owl.theme.default.min.css" -->
<!-- https://medium.com/@oleksandr_k/a-way-to-show-a-prompt-to-install-your-angular-pwa-both-on-android-and-ios-devices-7a770f55c54 -->
<!-- https://www.wordstream.com/popular-keywords/computer-keywords -->
